'use strict';

angular.module('Services')
    .factory('Profile', function ($http, $rootScope, Error, Request, Base64) {
        var service = {};


        service.getUser = function(callback) {
            Request.get({
                url: ApiURLs.user.account,
                successCallback: callback,
                errorCallback: callback
            });
        };
        service.saveUser = function(data, successCallback, errorsCallback) {
            Request.post({
                method: 'PUT',
                url: ApiURLs.user.account,
                successCallback: successCallback,
                errorCallback: errorsCallback
            }, data);
        };

        service.setPassword = function(data, successCallback, errorsCallback) {
            Request.post({
                method: 'POST',
                url: ApiURLs.user.password,
                successCallback: successCallback,
                errorCallback: errorsCallback
            }, data);
        };

        service.getCompgetany = function(callback) {
            Request.get({
                url: ApiURLs.user.company,
                successCallback: callback,
                errorCallback: callback
            });
        };

        service.saveCompany = function(data, successCallback, errorsCallback) {
            Request.post({
                method: 'PUT',
                url: ApiURLs.user.company,
                successCallback: successCallback,
                errorCallback: errorsCallback
            }, data);
        };

        service.savePhoto = function(file, successCallback, errorsCallback) {
            Request.upload({
                method: 'POST',
                url: ApiURLs.user.photo,
                successCallback: successCallback,
                errorCallback: errorsCallback
            }, file);
        };

        service.getPhoto = function(params, successCallback, errorsCallback) {
            Request.getFile({
                url: ApiURLs.user.photo,
                data: params,
                successCallback: successCallback,
                errorCallback: errorsCallback
            });
        };

        return service;
    }
);


// WEBPACK FOOTER //
// ./js/services/user.js